import {Component, inject, OnInit} from '@angular/core';
import {Button} from 'primeng/button';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputNumberModule} from 'primeng/inputnumber';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {AuthenticationService} from '../../../../services/auth/authentication.service';
import {InputOtpModule} from 'primeng/inputotp';
import {RestErrorHelper} from '../../../../helper/rest-error-helper';
import {VerifyMailComponent} from '../../generic/verify-mail/verify-mail.component';
import {environment} from '../../../../../environments/environment';
import {PlayerAuthenticationService} from '../../../player/service/player-authentication.service';
import {PlayerProfileService} from '../../../player/service/player-profile.service';

@Component({
  selector: 'app-change-mailaddress',
  standalone: true,
  imports: [
    Button,
    FormsModule,
    InputNumberModule,
    ReactiveFormsModule,
    TranslatePipe,
    InputOtpModule,
    VerifyMailComponent
  ],
  templateUrl: './change-mailaddress.component.html',
  styleUrl: './change-mailaddress.component.scss'
})
export class ChangeMailaddressComponent implements OnInit
{
  private restErrorHelper = inject(RestErrorHelper);
  private authenticationService = inject(AuthenticationService);
  private playerAuthenticationService = inject(PlayerAuthenticationService);
  private playerProfileService = inject(PlayerProfileService);
  private ref = inject(DynamicDialogRef);
  private config = inject(DynamicDialogConfig);

  playerProfile: boolean;
  baseUrlPlayerProfile = environment.baseUrlPlayerProfile;
  baseUrlDefault = environment.baseUrlUsermanagement;

  oldMail: string;
  newMail: string;
  mailConfirmed: boolean;

  isSaving: boolean;

  public static showDialog(dialogService: DialogService, translate: TranslateService, playerProfile?: boolean):
    DynamicDialogRef
  {
    return dialogService.open(
      ChangeMailaddressComponent,
      {
        header: translate.instant('CHANGE_MAIL_ADDRESS'),
        width: '600px',
        data: {playerProfile},
        dismissableMask: true,
        closable: true,
        modal: true,
        styleClass: 'dynamicDialog'
      });
  }

  ngOnInit(): void
  {
    this.playerProfile = this.config.data?.playerProfile;
    if (this.playerProfile)
      this.oldMail = this.playerAuthenticationService.username;
    else this.oldMail = this.authenticationService.userMail;
  }

  public onCancelClicked(): void
  {
    if (!this.isSaving)
      this.ref.close({ success: false });
  }

  public changeMailAdress(): void
  {
    if (this.isSaving || !(this.newMail) || !this.mailConfirmed)
      return;

    this.isSaving = true;
    if (this.playerProfile)
    {
      this.playerProfileService.changeMailAddress(this.newMail).subscribe({
        next: data =>
        {
          console.log('E-Mail Adresse geändert', data);
          this.isSaving = false;
          this.restErrorHelper.showInfoMessageService('MAIL_ADDRESS_CHANGED_SUCCESSFULLY', environment.toastDurationShort);
          this.playerAuthenticationService.username = this.newMail;
          this.ref.close(true);
        },
        error: error =>
        {
          this.isSaving = false;
          this.restErrorHelper.handleErrorService(error);
        }
      });
    }
    else
    {
      this.authenticationService.changeMailAddress(this.newMail).subscribe({
        next: data =>
        {
          console.log('E-Mail Adresse geändert', data);
          this.isSaving = false;
          this.restErrorHelper.showInfoMessageService('MAIL_ADDRESS_CHANGED_SUCCESSFULLY', environment.toastDurationShort);
          this.authenticationService.userMail = this.newMail;
          this.ref.close(true);
        },
        error: error =>
        {
          this.isSaving = false;
          this.restErrorHelper.handleErrorService(error);
        }
      });
    }
  }
}
